module.exports = __webpack_public_path__ + "static/media/password-recovery.1d23fb90.svg";